// extracted by mini-css-extract-plugin
export default {"eventName":"challenge-card-module--eventName--69MHi","logo":"challenge-card-module--logo--NyOUP"};